import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2fa7dc12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "required-settings__content" }
const _hoisted_2 = { class: "required_settings__description" }
const _hoisted_3 = { class: "required-settings__list-item-content" }
const _hoisted_4 = { class: "required-settings__show-settings" }

import { ALERT_TYPES, SIZES, FORMATS } from '@/enums/components'
import { computed, PropType, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { Company } from '@/models/company.model'
import { ROUTE_PATHS } from '@/router/paths'
import BaseButton from '@/components/BaseButton.vue'
import { RouteLocationNamedRaw } from 'vue-router'

interface MissingSetting {
  description: string
  route: RouteLocationNamedRaw
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RequiredSettingsOverviewAlert',
  props: {
  modelValue: {
    type: Object as PropType<Company>,
    required: true,
  },
  alertType: {
    type: String as PropType<ALERT_TYPES>,
    default: ALERT_TYPES.WARNING,
  },
},
  setup(__props) {

const props = __props



const i18n = useI18n()

// we show related button only if there are more than one missing settings
const showAllMissing = ref<boolean>(false)

const company = computed<Company>(() => props.modelValue)

const missingSettings = computed<MissingSetting[]>(() => {
  const missingSettings: MissingSetting[] = []

  if (!company.value) {
    return missingSettings
  }

  if (!company.value.is_agreed_contract) {
    missingSettings.push({
      description: i18n.t('requiredSettingsAlert.companyContractNotAgreedText'),
      route: {
        name: ROUTE_PATHS.SETTINGS_PROFILE,
        hash: '#contract',
      },
    })
  }

  if (!company.value.has_payment_details) {
    missingSettings.push({
      description: i18n.t('requiredSettingsAlert.paymentInfoNotFilledText'),
      route: {
        name: ROUTE_PATHS.SETTINGS_PROFILE,
        hash: '#payment-details',
      },
    })
  }

  if (!company.value.has_beneficial_owner) {
    missingSettings.push({
      description: i18n.t(
        'requiredSettingsAlert.beneficialOwnersNotFilledText',
      ),
      route: {
        name: ROUTE_PATHS.SETTINGS_PROFILE,
        hash: '#beneficial-owners',
      },
    })
  }

  if (!company.value.has_service_contract) {
    missingSettings.push({
      description: i18n.t('requiredSettingsAlert.companyNoServiceContract'),
      route: {
        name: ROUTE_PATHS.SETTINGS_CONTRACTS,
        hash: '#settings-contracts',
      },
    })
  }

  return missingSettings
})

const renderedMissingSettings = computed<MissingSetting[]>(() => {
  if (showAllMissing.value) {
    return missingSettings.value
  }
  // we only show one item when show all is not enabled
  return missingSettings.value.slice(0, 1)
})

const anyRequiredSettingsUnset = computed<boolean>(() => {
  return missingSettings.value.length > 0
})

const showHideButtonLabel = computed<string>(() => {
  if (showAllMissing.value) {
    return i18n.t('requiredSettingsAlert.hideMoreSettingsLabel')
  } else {
    const hiddenCount =
      missingSettings.value.length - renderedMissingSettings.value.length
    return i18n.t('requiredSettingsAlert.dynamicShowAllLabel', {
      count: hiddenCount,
    })
  }
})

return (_ctx: any,_cache: any) => {
  const _component_AlertBanner = _resolveComponent("AlertBanner")!

  return (_unref(anyRequiredSettingsUnset))
    ? (_openBlock(), _createBlock(_component_AlertBanner, _mergeProps({
        key: 0,
        "alert-type": __props.alertType,
        class: "required-settings"
      }, _ctx.$attrs), {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('settings.ServicePublishWarning')), 1),
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(renderedMissingSettings), (missingSetting, missingSettingIndex) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: missingSettingIndex,
                  class: "required-settings__requirement"
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("p", null, _toDisplayString(missingSetting.description), 1),
                    _createVNode(BaseButton, {
                      label: _ctx.$t('takeMeThere'),
                      format: _unref(FORMATS).TERTIARY,
                      size: _unref(SIZES).SMALL,
                      type: "button",
                      class: "required-settings__button",
                      onClick: ($event: any) => (_ctx.$router.push(missingSetting.route))
                    }, null, 8, ["label", "format", "size", "onClick"])
                  ])
                ]))
              }), 128))
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_4, [
              _createVNode(BaseButton, {
                label: _unref(showHideButtonLabel),
                format: _unref(FORMATS).TERTIARY,
                size: _unref(SIZES).SMALL,
                icon: showAllMissing.value ? 'chevron-up' : 'chevron-down',
                "icon-right": true,
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (showAllMissing.value = !showAllMissing.value), ["prevent"]))
              }, null, 8, ["label", "format", "size", "icon"])
            ], 512), [
              [_vShow, _unref(missingSettings).length > 1]
            ])
          ])
        ]),
        _: 1
      }, 16, ["alert-type"]))
    : _createCommentVNode("", true)
}
}

})